export const OverallColums = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "时间",
    dataIndex: "placeholder",
    key: "1",
  },
  {
    title: "类型",
    dataIndex: "placeholder",
    key: "2",
  },
  {
    title: "签收数量",
    dataIndex: "placeholder",
    key: "3",
  },
  {
    title: "简单检品数量",
    dataIndex: "placeholder",
    key: "4",
  },
  {
    title: '移库数量(正品库)',
    dataIndex: 'placeholder',
    key: '5',
  },
  {
    title: '拣货数量',
    dataIndex: 'placeholder',
    key: '6',
  },
  {
    title: '当日上架数',
    dataIndex: 'placeholder',
    key: '7',
  },
  {
    title: '未上架数',
    dataIndex: 'placeholder',
    key: '8',
  },
];
